import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'sso-wsfed',
    components: {
    },
})

export default class SSOwsfed extends Vue {
    @Prop()
    private ssoDetails: any;

    private ssoFields: any = {
        idpUrl: {
            name: 'idpUrl',
            field: 'b-form-input',
            modelKey: 'idpUrl',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        thumbprint: {
            name: 'Thumbprint',
            field: 'b-form-input',
            modelKey: 'thumbprint',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
    };
}
